import { render, staticRenderFns } from "./AccountPrivate.vue?vue&type=template&id=525e5a73&"
import script from "./AccountPrivate.vue?vue&type=script&lang=js&"
export * from "./AccountPrivate.vue?vue&type=script&lang=js&"
import style0 from "./AccountPrivate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports